import Backbone from 'backbone';
import { AddToRegistry } from '../util/Constants';
import { getProperty } from '../util/PropertyGetter';


export default Backbone.Model.extend({

  url() {
    return this.currentUrl ? this.currentUrl : AddToRegistry.addToRegistryUrl;
  },

  defaultTraits: {
    DEFAULT_COLOR: 'NA',
    DEFAULT_SIZE: 'NA',
    DEFAULT_TYPE: 'NA',
  },

  initialize(data, options) {
    Object.assign(this, options);
    const viewState = this.productModel.get('viewState');
    const product = this.productModel.get('product');
    const { selectedPrice } = viewState.detail;
    this.set('source', this.source);
    this.set('productId', this.getSelectedProductId(viewState, product));
    this.set('name', product.detail.name);
    this.set('brand', product.detail.brand && product.detail.brand.name);
    this.set('selectedPrice', selectedPrice);
    this.set('quantity', viewState.detail.selectedQuantity);
    this.set('color', this.getSelectedColor(viewState, product));
    this.set('size', this.getSelectedSize(viewState));
    this.set('type', this.getSelectedType(viewState));
    this.set('price', this.getPrice(selectedPrice));
    this.set('breadCrumbCategory', viewState.detail.breadCrumbCategory);
    this.set('selectedImage', viewState.imagery && viewState.imagery.images[0] && viewState.imagery.images[0].filePath);
  },

  getSelectedProductId(viewState, product) {
    const consolidatedProductComplex = getProperty(viewState, 'detail.flags.consolidatedProductComplex', false);
    const selectedUPC = getProperty(viewState, 'detail.selectedUpc', false);
    if (consolidatedProductComplex && selectedUPC) {
      return getProperty(product, `relationships.upcs[${selectedUPC}].relationships.selectedProduct`);
    }
    return product.id;
  },

  getSelectedColor(viewState, product) {
    let selectedColor = this.defaultTraits.DEFAULT_COLOR;
    const { color: colorTraits } = viewState.traits;
    if (colorTraits) {
      const swatchTierIndex = Number(colorTraits.selectedTierIndex) || 0;
      const selectedSwatchIndex = Number(colorTraits.selectedSwatchIndex) || 0;
      selectedColor = product.traits.colors.colorMap[colorTraits.swatchTiers[swatchTierIndex].swatches[selectedSwatchIndex].id].name;
    }
    return selectedColor;
  },

  getSelectedSize(viewState) {
    const { size: sizeTraits } = viewState.traits;
    let { DEFAULT_SIZE: selectedSize } = this.defaultTraits;
    if (sizeTraits) {
      const swatchTierIndex = Number(sizeTraits.selectedTierIndex || 0);
      const selectedSwatchIndex = Number(sizeTraits.selectedSwatchIndex || 0);
      selectedSize = sizeTraits.swatchTiers[swatchTierIndex].swatches[selectedSwatchIndex].displayName;
    }
    return selectedSize;
  },

  getSelectedType(viewState) {
    const { type: typeTraits } = viewState.traits;
    let { DEFAULT_TYPE: selectedType } = this.defaultTraits;
    if (typeTraits) {
      const swatchTierIndex = Number(typeTraits.selectedTierIndex || 0);
      const selectedSwatchIndex = Number(typeTraits.selectedSwatchIndex || 0);
      selectedType = typeTraits.swatchTiers[swatchTierIndex].swatches[selectedSwatchIndex].displayName;
    }
    return selectedType;
  },

  getPrice(selectedPrice) {
    let price = '';
    const tieredPrice = selectedPrice && selectedPrice.price && selectedPrice.price.tieredPrice;
    if (tieredPrice) {
      price = tieredPrice[tieredPrice.length - 1].values[0].value;
    }
    return price;
  },


});



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/add-to-registry/AddToRegistryModel.js